/**
 * Messa in sicurezza dei valori che finiscono nell'HTML di una email.
 * Nessuna dipendenza esterna: dompurify non c'e' in questo progetto e in Deno
 * servirebbe un secondo pacchetto, con il rischio che browser e server si
 * comportino in modo diverso proprio sulla parte che deve proteggere.
 */

export function escapeHtml(testo: string): string {
  return testo
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

const PROTOCOLLI_AMMESSI = ['http:', 'https:', 'mailto:', 'tel:'];

/**
 * Restituisce l'URL se e' di un tipo che ha senso in una email, altrimenti
 * stringa vuota. Serve a bloccare `javascript:` e `data:`, con cui un link
 * apparentemente innocuo esegue codice nel client di chi legge.
 *
 * Il controllo e' sul protocollo e non su una lista di parole vietate, perche'
 * una lista di parole si aggira con maiuscole, spazi e caratteri invisibili.
 */
export function sanitizeUrl(url: string): string {
  const pulito = url.trim();
  if (!pulito) return '';

  // Un URL senza protocollo e' un link relativo: dentro una email non
  // funziona, ma non e' pericoloso. Lo lasciamo passare come https.
  const daAnalizzare = /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(pulito) ? pulito : `https://${pulito}`;

  try {
    const analizzato = new URL(daAnalizzare);
    if (!PROTOCOLLI_AMMESSI.includes(analizzato.protocol)) return '';
    return analizzato.toString();
  } catch {
    return '';
  }
}

/** URL pronto per finire dentro un attributo href. */
export function urlPerAttributo(url: string): string {
  return escapeHtml(sanitizeUrl(url));
}
